export type State = boolean
export type Action = { type: 'toggleGlobalMenu' }

export default function GlobalMenuOpener(state: State, action: Action): State {
  switch (action.type) {
    case 'toggleGlobalMenu':
      return !state
    default:
      return state
  }
}
